import { Inbox } from 'lucide-react';
import { ReactNode } from 'react';

/**
 * État vide — remplace antd Empty.
 */
const Empty = (props: { description?: ReactNode; icon?: ReactNode; size?: number }) => (
    <div className="flex flex-col items-center justify-center py-10 text-center">
        <div className="text-[var(--eb-text-muted)]/50 mb-3">
            {props.icon || <Inbox size={props.size || 44} strokeWidth={1.2} />}
        </div>
        <p className="text-sm text-[var(--eb-text-muted)]">
            {props.description || 'Aucune donnée'}
        </p>
    </div>
);

export default Empty;
